/* eslint-disable */
import axios from 'axios'

export default {
    namespaced: true,
    state: {
        nonRegIndiv: [],
    },
    mutations: {
        getIndiv(state, indiv) {
            state.nonRegIndiv = indiv
        },
    },
    getters: {
        getIndiv: (state) => state.nonRegIndiv,
    },
    actions: {
        async retrieveNonRegIndiv({ commit }, id) {
            console.log('twas here')
            await axios
                .get('/api/nonRegIndividual/' + id)
                .then((result) => {
                    commit('getIndiv', result.data)
                })
                .catch((e) => console.log(e))
        },
    },
}